import { Injectable } from '@angular/core';
import { SelectItem } from '@web/shared/ui';
import { Observable, of } from 'rxjs';
import { PublicBrandCosmeticSortType } from '../types/public-brand-cosmetic-sort-type';

@Injectable({
  providedIn: 'root',
})
export class PublicBrandCosmeticSortTypeSelectItemsProviderService {
  private readonly entries = new Map<PublicBrandCosmeticSortType, string>([
    [PublicBrandCosmeticSortType.NameAscending, 'Nazwa rosnąco'],
    [PublicBrandCosmeticSortType.NameDescending, 'Nazwa malejąco'],
    [PublicBrandCosmeticSortType.CreatedAtAscending, 'Najstarsze'],
    [PublicBrandCosmeticSortType.CreatedAtDescending, 'Najnowsze'],
  ]);

  public selectItems(): Observable<SelectItem<PublicBrandCosmeticSortType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) =>
          new SelectItem<PublicBrandCosmeticSortType>(label, type),
      ),
    );
  }
}
